<template>
    <v-ons-page id="submenuPage">
        <v-ons-toolbar>
            <div class="left zindex9 icon-left">
              <v-ons-back-button material></v-ons-back-button>
            </div>
            <div :class="{'text-center minus7-ml':'!back' }" class="center zindex1">
                <slot></slot>
                <!--<slot v-if="!title"> TABLAS DE LA CATEDRAL DE SEGOVIA </slot>-->
            </div>
            <div class="right zindex9 icon-right" @click="pushMap()">
                <img :src="icon_map">
            </div>
        </v-ons-toolbar>
        <!--<div class="header">-->
        <!--<img src="../assets/onsenui-logo.png">-->
        <!--</div>-->

        <ons-list>
            <ons-list-item class="padding0" tappable @click="push(item)" v-for="(item,index) in fullMenuItems"
                           :key="index">

                <!--<div class="left"></div>-->
                <div class="center">
                    <div class="content">
                        <img :src="require('../assets/img/art/'+item.imageMenu)" height="100%" width="100%"/>
                        <div class="borderMenu"></div>
                        <div class="titleSubmenu font22pt">{{item.title}}</div>

                        <div class="author font18pt">{{item.author}}</div>
                    </div>

                </div>
            </ons-list-item>
        </ons-list>
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'
    import constants from '../constants'
    import AudioPage from './AudioPage'
    import TextPage from './TextPage'
    import GalleryPage from './GalleryPage'
    import ImagePage from './ImagePage'

    export default {
        name: 'submenu',
        components: {
            TopBar,
        },
        data: function () {
            return {
                icon_back: require('../assets/img/UI/volver_rojo.svg'),
                icon_map: require('../assets/img/UI/gota_mapa.png'),

            }
        },
        props: [
            'title',
            'map',
            'menuItems'
        ],
        /*data: function () {
            return {
                menuItems: this.$t("message.menuItems"),

            }
        },*/
        computed: {
            visitType: {
                get() {
                    return this.$store.state.visit.type
                },
            },
            fullMenuItems() {
                console.log("fullMenuItems submenu");
              this.menuItems.forEach((elementMenuItem,indexItem) => {


                var idioma="";
                let lang=this.$i18n.locale;

                if (lang == "Castellano") {
                  idioma = "ESP";
                } else if (lang == "English") {
                  idioma = "ENG";
                } else if (lang == "Français") {
                  idioma = "FRA";
                } else if (lang == "Català") {
                  idioma = "CAT";
                } else if (lang == "Deutsch") {
                  idioma = "DEU";
                } else if (lang == "Português") {
                  idioma = "POR";
                } else if (lang == "한국어") {
                  idioma = "KOR";
                } else if (lang == "官話") {
                  idioma = "CHI";
                }

                elementMenuItem.path_audio =  "/audios/"+idioma+"/"+ elementMenuItem.audio;

                if(elementMenuItem.isCredits) {
                  elementMenuItem.imgCredit = elementMenuItem.img;
                }


                console.log(elementMenuItem.path_audio);
              });
              return this.menuItems;
            }
        },
        mounted() {
            /*item=document.querySelector('.list-item:first-child');
            compStyles = window.getComputedStyle(item);
            alert(compStyles.getPropertyValue('width'));*/
            /*Array.from(document.getElementsByClassName("list-item")).forEach(function(item) {
                console.log(item);
                if (item instanceof HTMLElement) {

                    compStyles = window.getComputedStyle(item);
                    alert(compStyles.getPropertyValue('width'));

                    console.log(item.height);
                    console.log(item.style.height);
                    item.style.width = "100px";
                }
            });*/


            /*Array.from(document.getElementsByClassName("titleSubmenu")).forEach(function(item) {
                console.log(item);
                if (item instanceof HTMLElement) {
                    console.log(item.height);
                    console.log(item.style.height);
                   item.style.width = (screen.width/2-((screen.width*7)/100))+"px";
                }
            });*/




            //jQuery(".content .title").width("100px !importat");
            //$(".content .title").width($("ons-list-item").width()+"px");
        },
        methods: {
            push(item) {
                if (item.isGallery) {
                    this.$emit('push', {
                        extends: GalleryPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                } else if (item.isCredits) {
                    this.$emit('push', {
                        extends: TextPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                }
                else if (this.$store.state.visit.type === constants.VISIT_TYPE_READ) {

                    this.$emit('push', {
                        extends: TextPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                } else if (this.$store.state.visit.type === constants.VISIT_TYPE_LISTEN || this.$store.state.visit.type === constants.VISIT_TYPE_COMPLETE || this.$store.state.visit.type === constants.VISIT_TYPE_SHORT) {
                    if (item.imagesAudio) {
                        item.img = item.imagesAudio[0].img;
                        console.log('HASSS IMAGES AUDIOOOS¡¡¡¡');
                        console.log(item.imagesAudio);
                    }
                    this.$emit('push', {
                        extends: AudioPage,
                        onsNavigatorProps: {
                            item: item,
                            menuElements:this.menuItems
                        }
                    });
                }

//                this.$i18n.locale = lang;
//                this.$store.commit('langs/toggle', lang)
//                this.$emit('push', {
//                    extends: MenuPage,
//
//                });
            },
            pop(){
                this.$emit('pop');
            },
            pushMap(){
                this.$emit('push', {
                    extends: ImagePage,
                    onsNavigatorProps: {
                        image: this.map,
                        title: this.title

                    }
                });
            }
        },
    }
</script>

<style lang="css" src="../assets/css/styles.css"/>
<style scoped>



    .padding0 {
        padding: 0;
    }

    #menuPage .list-item__center {
        padding: 0;

    }

    .content {
        margin: 0px 0px -6px 0px;
        width: 100%;
      position: relative;
    }

    .titleSubmenu {

      position: absolute;
      text-overflow: ellipsis;
      overflow: hidden;
      bottom: 6.5%;
      width: 90%;
      left: 5%;
      text-align: center;
      color: #fff;
      line-height: 19px;
      height: 28%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .borderMenu {
        /*border-top: 1px solid rgb(160,16,33);*/
        border:0;
        width: 12%;
        margin-left: 43%;
        margin-top: 5px;
    }

    .list-item {
        margin: 0;
        float: left;
        width: 50%;
    }

    .author {
        position: absolute;
        bottom: 2%;
        left: 17%;
        /*font-size: 18pt;*/
    }

    ons-list {
        margin: 0 7%;
    }

    .list-item__center {
        background: none !important;
    }

    ons-list-item:nth-child(even) { padding-left:4%;  }
    ons-list-item:nth-child(odd) { padding-right:4%; clear: both}

    @media (min-width: 800px) {
      .titleSubmenu {
        bottom: 5%;
        line-height: 23px;
      }

    }


</style>



// WEBPACK FOOTER //
// src/pages/SubmenuPage.vue